import {
  Box,
  Typography,
  Chip,
  Stack,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";
import LocalFireDepartmentRoundedIcon from "@mui/icons-material/LocalFireDepartmentRounded";
import { useDispatch, useSelector } from "react-redux";
import {
  removeIngredient,
  clearIngredients,
  setConfirmOpen,
} from "../ingredientsListSlice";

const IngredientList = () => {
  const dispatch = useDispatch();
  const { ingredients, confirmOpen } = useSelector(
    (state) => state.ingredientsList
  );

  if (ingredients.length === 0) return null;

  const handleRemove = (removed) => {
    dispatch(removeIngredient(removed));
  };

  return (
    <Box sx={{ mb: 2.5 }}>
      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{ fontWeight: 800, color: "text.primary" }}
      >
        Selected Ingredients:
      </Typography>

      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {ingredients.map((ingredient, idx) => (
          <Chip
            key={idx}
            label={ingredient}
            data-testid={`chip-${ingredient}`}
            onDelete={() => handleRemove(ingredient)}
            icon={<LocalFireDepartmentRoundedIcon />}
            sx={{
              mb: 1,
              bgcolor: "rgba(250, 204, 21, 0.22)",
              color: "text.primary",
              border: "1px solid rgba(249, 115, 22, 0.22)",
              fontWeight: 700,
              "& .MuiChip-deleteIcon": {
                color: "primary.main",
              },
              "& .MuiChip-icon": {
                color: "primary.main",
              },
            }}
          />
        ))}
      </Stack>

      {ingredients.length >= 2 && (
        <Box sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => dispatch(setConfirmOpen(true))}
            sx={{ borderRadius: 2, fontWeight: 700 }}
          >
            Clear All
          </Button>
        </Box>
      )}

      <Dialog
        open={confirmOpen}
        onClose={() => dispatch(setConfirmOpen(false))}
      >
        <DialogTitle>
          Are you sure you want to remove all ingredients?
        </DialogTitle>
        <DialogContent sx={{ color: "text.secondary", pt: "4px !important" }}>
          This will empty your ingredient basket so you can start a fresh meal
          idea.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => dispatch(setConfirmOpen(false))}>
            Cancel
          </Button>
          <Button
            color="error"
            onClick={() => {
              dispatch(clearIngredients());
              dispatch(setConfirmOpen(false));
            }}
          >
            Yes, Clear All
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default IngredientList;
